import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import MonadNavBar from '../components/monad/MonadNavBar';
import MonadTokenList from '../components/monad/MonadTokenList';
import CreateMonadTokenModal from '../components/monad/CreateMonadTokenModal';
import MonadPriceFooter from '../components/monad/MonadPriceFooter';

// Monad Brand Colors
const MONAD_PURPLE = '#836EF9';
const MONAD_BLUE = '#200052';
const MONAD_BERRY = '#A0055D';
const MONAD_BLACK = '#0E100F';
const MONAD_OFF_WHITE = '#FBFAF9';

const ExploreContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  background: transparent;
`;

const HeaderSection = styled.div`
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  padding: 40px 24px 0;
  box-sizing: border-box;
  
  @media (max-width: 700px) {
    padding: 24px 16px 0;
  }
`;

const HeaderImage = styled.img`
  width: 100%;
  max-width: 800px;
  height: auto;
  border-radius: 16px;
  object-fit: cover;
  display: block;
  margin: 0 auto;
  
  @media (max-width: 700px) {
    border-radius: 12px;
    max-width: 100%;
  }
`;

const CreateButtonSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px;
  max-width: 1920px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
  
  @media (max-width: 700px) {
    padding: 16px 8px;
  }
`;

const CreateTokenButton = styled.button`
  padding: 10px 24px;
  background: linear-gradient(135deg, ${MONAD_PURPLE} 0%, ${MONAD_BERRY} 100%);
  border: 2px solid ${MONAD_PURPLE};
  border-radius: 8px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  font-family: 'Inter', sans-serif;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;

  &:hover {
    background: linear-gradient(135deg, ${MONAD_PURPLE} 0%, ${MONAD_BERRY} 100%);
    opacity: 0.9;
    transform: translateY(-2px);
    box-shadow: 0 4px 20px rgba(131, 110, 249, 0.4);
  }

  @media (max-width: 700px) {
    width: 100%;
    padding: 12px 24px;
  }
`;


const MainContainer = styled.div`
  flex: 1;
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  padding: 0 24px 40px;
  box-sizing: border-box;

  @media (max-width: 700px) {
    padding: 0 8px 24px;
    max-width: 100%;
  }
`;

const MonadPage: React.FC = () => {
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  const handleCreateSuccess = () => {
    // Refresh token list if needed
    window.location.reload(); // Simple refresh for now
  };

  return (
    <ExploreContainer>
      {/* Custom Monad Navigation Bar */}
      <MonadNavBar />

      {/* Header Image */}
      <HeaderSection>
        <HeaderImage
          src="/monad-money-markets-header.png"
          alt="Monad Money Markets"
        />
      </HeaderSection>

      {/* Create Token Button Section */}
      <CreateButtonSection>
        <CreateTokenButton onClick={() => setIsCreateModalOpen(true)}>
          Create Token
        </CreateTokenButton>
      </CreateButtonSection>

      {/* Token List */}
      <MainContainer>
        <MonadTokenList searchQuery="" />
      </MainContainer>

      {/* Create Token Modal */}
      <CreateMonadTokenModal
        isOpen={isCreateModalOpen}
        onClose={() => setIsCreateModalOpen(false)}
        onSuccess={handleCreateSuccess}
      />

      {/* Monad Price Footer */}
      <MonadPriceFooter />
    </ExploreContainer>
  );
};

export default MonadPage;

